module.exports = __webpack_public_path__ + "img/balcon-3.b8f0ee66.webp";